import { createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  StatGenerali,
  AndamentoMensile,
  AndamentiQueryParams,
  StatsFlussoMensile,
  StatsPie
} from '../../core/models/stats.model';

export const StatsActions = createActionGroup({
  source: 'Stats',
  events: {
    'Load Stats': props<{ year: number }>(),
    'Load Stats Success': props<{ stats: StatGenerali }>(),
    'Load Stats Failure': props<{ error: string }>(),

    'Load Years': emptyProps(),
    'Load Years Success': props<{ years: number[] }>(),
    'Load Years Failure': props<{ error: string }>(),

    'Select Year': props<{ year: number }>(),

    'Load Andamenti Mensili': props<{ params?: AndamentiQueryParams }>(),
    'Load Andamenti Mensili Success': props<{ items: AndamentoMensile[]; totalElements: number; totalPages: number; pageIndex: number }>(),
    'Load Andamenti Mensili Failure': props<{ error: string }>(),

    'Load Pie': props<{ anno: number }>(),
    'Load Pie Success': props<{ data: StatsPie }>(),
    'Load Pie Failure': props<{ error: string }>(),

    'Load Flusso Mensile': props<{ anno: number }>(),
    'Load Flusso Mensile Success': props<{ data: StatsFlussoMensile[] }>(),
    'Load Flusso Mensile Failure': props<{ error: string }>(),
  },
});
